import * as S from "./styles";
import Left from "assets/left.svg";

interface CardProps {
  text: string;
  link: string;
  number: number;
}

export function InfoCard({ text, link, number }: CardProps) {
  return (
    <S.CardContainer to={link}>
      <div>
        <S.Badge>
          <span>{number}</span>
        </S.Badge>

        <S.Info>
          <p>{text}</p>
          <img src={Left} alt="left arrow icon" />
        </S.Info>
      </div>
    </S.CardContainer>
  );
}
